import DashboardBottomMenu from './DashboardBottomMenu';

export default DashboardBottomMenu;
